import styled from 'styled-components';

export const PastEpisodesRow = styled.tr`
  td {
    background-color: var(--surface-default);
  }
`;
